// **********************************************************
// Parallax Module
// **********************************************************

const parallaxNodeList = document.querySelectorAll('.parallax-module__images-item');
const parallaxImages = Array.from(parallaxNodeList);

if (parallaxImages.length > 0 && window.innerWidth >= breakpointMd) {
  const maxMove = 25;

  const currentPositions = parallaxImages.map(() => ({ x: 0, y: 0 }));
  const targetPositions = parallaxImages.map(() => ({ x: 0, y: 0 }));

  const eases = parallaxImages.map(() => 0.03 + Math.random() * 0.06);

  // opacity system
  const currentOpacity = parallaxImages.map(() => 1);
  const targetOpacity = parallaxImages.map(() => 0.5 + Math.random() * 0.5);
  const opacityEases = parallaxImages.map(() => 0.01 + Math.random() * 0.02);

  const onMouseMove = (event) => {
    const mouseX = (event.clientX / window.innerWidth - 0.5) * 2;
    const mouseY = (event.clientY / window.innerHeight - 0.5) * 2;

    parallaxImages.forEach((_, index) => {
      const directionX = index % 2 === 0 ? 1 : -1;
      const directionY = index % 2 === 0 ? -1 : 1;

      targetPositions[index].x = mouseX * maxMove * directionX;
      targetPositions[index].y = mouseY * maxMove * directionY;
    });
  };

  const parallaxAnimate = () => {
    parallaxImages.forEach((item, index) => {
      // ---- Position animation ----
      currentPositions[index].x += (targetPositions[index].x - currentPositions[index].x) * eases[index];
      currentPositions[index].y += (targetPositions[index].y - currentPositions[index].y) * eases[index];

      // ---- Opacity animation ----
      currentOpacity[index] += (targetOpacity[index] - currentOpacity[index]) * opacityEases[index];

      if (Math.abs(targetOpacity[index] - currentOpacity[index]) < 0.02) {
        targetOpacity[index] = 0.5 + Math.random() * 0.5;
      }

      item.style.transform = `translate3d(
        ${currentPositions[index].x}px,
        ${currentPositions[index].y}px,
        0
      )`;

      item.style.opacity = currentOpacity[index];
    });

    requestAnimationFrame(parallaxAnimate);
  };

  document.addEventListener('mousemove', onMouseMove);
  parallaxAnimate();
}

// **********************************************************
// Scroll Animation - Parallax effect for items 9 and 10
// **********************************************************

const parallaxModules = document.querySelectorAll('.parallax-module');

if (window.innerWidth >= breakpointMd) {
  parallaxModules.forEach((module) => {
    const item9 = module.querySelector('.parallax-module__images-item--9');
    const item10 = module.querySelector('.parallax-module__images-item--10');

    if (!item9 || !item10) return;

    item9.style.transition = 'none';
    item10.style.transition = 'none';

    const handleParallax = () => {
      const rect = module.getBoundingClientRect();
      const parallaxOffset = (window.innerHeight - rect.top) * 0.5;
      item9.style.top = `calc(85% - ${parallaxOffset * 0.3}px)`;
      item10.style.top = `calc(92% - ${parallaxOffset * 0.35}px)`;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', handleParallax, { passive: true });
            handleParallax();
          } else {
            window.removeEventListener('scroll', handleParallax);
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(module);
  });
}
